import React, { Fragment, useState, useEffect } from 'react';
import {
  Box,
  CardMedia,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  Switch,
  TextField,
  Typography,
  InputAdornment,
  MenuItem,
  Button,
  FormHelperText
} from '@mui/material';
import { FacebookRounded, Instagram, WhatsApp, X, LinkedIn, Close, KeyboardArrowLeft } from '@mui/icons-material';
import Colors from '../../../Assets/Styles/Colors';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import { OutlineInputField, InputField } from '../../../Components/Fields/TextFields';
import SelectField from '../../../Components/Fields/SelectField';
import { PrimaryButton } from '../../../Components/Buttons';
import { PhotoLibrary } from '@mui/icons-material';
import styled from '@emotion/styled';
import { useForm } from 'react-hook-form';
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices';
import { baseUrl } from '../../../../axios';
import AdreadServices from '../../../Api/AdRead/AdReadServices';
import { useNavigate } from 'react-router-dom';
import { ErrorToaster, SuccessToaster } from '../../../Components/Toaster/Toaster';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import "./index.css"
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : Colors.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

function CreateAdRead() {
  const socialData = [
    {
      _id: 1001,
      value: "f_link",
      name: "Facebook",
      icon: <FacebookRounded sx={{ color: Colors.primary }} />
    },
    {
      _id: 1002,
      value: "t_link",
      name: "Twitter",
      icon: <X sx={{ color: Colors.primary }} />
    },
    {
      _id: 1003,
      value: "l_link",
      name: "LinkedIn",
      icon: <LinkedIn sx={{ color: Colors.primary }} />
    },
    {
      _id: 1004,
      value: "w_link",
      name: "Instagram",
      icon: <Instagram sx={{ color: Colors.primary }} />
    },
  ]
  const [image, setImage] = useState("");
  const [label, setLabel] = useState("Active");
  const [isChecked, setIsChecked] = useState(true);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState({ id: "", name: "" });
  const [selectedSocial, setSelectedSocial] = useState({ id: "", name: "", value: "", icon: "" });
  const [socialMediaLink, setSocialMediaLink] = useState([]);
  const [link, setLink] = useState("");
  const [value, setValue] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();

  const navigate = useNavigate();

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const result = await CategoriesServices.uploadImage(formData);
      setImage(result?.data?.imageUrl)
    } catch (error) {
      console.log(error)
    }
  }

  const handleChecked = (e) => {
    setIsChecked(e.target.checked);
    setLabel(e.target.checked == true ? "Active" : "Inactive")
  }

  const submitForm = async (formData) => {
    const additionalLinks = socialMediaLink.reduce((acc, item) => {
      if (item.f_link) acc.f_link = item.f_link;
      if (item.t_link) acc.t_link = item.t_link;
      if (item.l_link) acc.l_link = item.l_link;
      if (item.w_link) acc.w_link = item.w_link;
      return acc;
    }, {});
    const obj = {
      title: formData?.AdReadTitle,
      category: selectedCategory?.id,
      image: image,
      date: selectedDate,
      content: value,
      status: isChecked,
      additional: additionalLinks,
      type: "adread"
    }
    if (image == "") {
      ErrorToaster("Please select an image")
    } else {
      setLoading(true);
      try {
        const result = await AdreadServices.createAdread(obj);
        if (result?.responseCode == 200) {
          SuccessToaster(result?.message);
          navigate("/adread-list");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  }

  const getAllCategories = async () => {
    try {
      const result = await CategoriesServices.getAllCategories("", 1, 100, "adread");
      const filteredCategories = result?.data?.categories?.filter((item) => item.isActive == true);
      setCategories(filteredCategories);
      // console.log(result);
    } catch (error) {
      console.log(error);
    }
  }

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSocialPlatform = (value) => {
    const selectedSocialPlatform = socialData.find(item => item.value == value);
    setSelectedSocial({
      id: selectedSocialPlatform._id,
      name: selectedSocialPlatform.name,
      value: selectedSocialPlatform.value,
      icon: selectedSocialPlatform.icon
    })

  }

  const handleLinkAdd = () => {
    const existingIndex = socialMediaLink.findIndex(item => item.name === selectedSocial.name);
    if (existingIndex !== -1) {
      // If link for selected platform already exists, update it
      const updatedSocialMediaLink = [...socialMediaLink];
      updatedSocialMediaLink[existingIndex][`${selectedSocial.value}`] = link;
      setSocialMediaLink(updatedSocialMediaLink);
    } else {
      // If link for selected platform doesn't exist, add it
      const obj = {
        [selectedSocial.value]: link,
        name: selectedSocial.name
      };
      setSocialMediaLink([...socialMediaLink, obj]);
    }
    setLink("")
  }

  const handleRemoveLink = (obj) => {
    const updatedSocialMediaLink = socialMediaLink.filter((item) => item.name !== obj.name);
    setSocialMediaLink(updatedSocialMediaLink);
  }

  const handleEditorReady = (editor) => {
    console.log('Editor is ready to use!', editor);
  };

  const handleEditorChange = (event, editor) => {
    console.log(event);
    console.log(editor);
    setValue(editor.getData());
    console.log(editor.getData());
  };

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return loader.file.then(file => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("image", file);

            axios
              .post("https://adstreet.mangotech-api.com/api/ad/uploadImage", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${localStorage.getItem("token")}`
                }
              })
              .then(response => {
                console.log(response);
                resolve({ default: `https://adstreet.mangotech-api.com${response.data.data.imageUrl}` });
              })
              .catch(error => {
                console.error("Error uploading file:", error);
                reject(error);
              });
          });
        });
      }
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = loader => {
      return uploadAdapter(loader);
    };
  }

  useEffect(() => {
    getAllCategories();
  }, [])

  return (
    <Fragment>
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Create AdRead
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Create AdRead"]} />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, p: 2, bgcolor: Colors.white, borderRadius: "12px" }}>
          <Grid container spacing={2} component={"form"} onSubmit={handleSubmit(submitForm)}>
            <Grid item md={12}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "20px", mb: 2 }}>
                <Typography>Status: </Typography>
                <FormControlLabel
                  sx={{
                    m: 0,
                    gap: "10px"
                  }}
                  control={
                    <CustomSwitch
                      checked={isChecked}
                      onChange={handleChecked}
                    />
                  }
                  label={<Typography sx={{ width: "60px" }}>{label}</Typography>}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <InputField
                  label={"Adread Title"}
                  register={register("AdReadTitle", {
                    required: "Please enter a title"
                  })}
                  error={errors?.AdbookTitle?.message}
                  helperText={errors?.AdbookTitle?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <SelectField
                  data={categories}
                  stateValue={selectedCategory.name}
                  setState={(id, name) => setSelectedCategory({ id: id, name: name })}
                  label={"Categories"}
                  register={register("category", {
                    required: "Pelase selec a category",
                  })}
                  error={errors?.category?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box
                sx={{
                  height: "120px",
                  border: image !== "" ? "none" : "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "4px",
                  ":hover": {
                    borderColor: image !== "" ? "transparent" : "#1F1F1F"
                  }
                }}
              >
                {image !== "" ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      position: "relative",
                      height: "100%",
                    }}
                  >
                    <CardMedia
                      component={"img"}
                      src={baseUrl + image}
                      sx={{
                        width: "120px",
                        height: "100%",
                        objectFit: "contain"
                      }}
                    />
                    <Box sx={{ position: "absolute", top: 0, right: 0 }}>
                      <IconButton sx={{ p: 0 }} onClick={() => setImage("")}>
                        <Close sx={{ color: Colors.primary }} />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  <Fragment>
                    <InputLabel
                      htmlFor="image-input"
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px"
                      }}
                    >
                      <PhotoLibrary sx={{ fontSize: "36px" }} />
                      <Typography>
                        Upload Image
                      </Typography>
                    </InputLabel>
                    <input
                      id="image-input"
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e.target.files[0])}
                      style={{ display: "none" }}
                    />
                  </Fragment>
                )}
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    {...register("date", {
                      required: selectedDate == null ? "Please select a date" : false
                    })}
                    label="Select Date"
                    slotProps={{
                      textField: {
                        fullWidth: true
                      }
                    }}

                    onChange={(date) => handleDateChange(date)}
                  />
                  <FormHelperText sx={{ color: errors?.date && Colors.danger }}>
                    {errors?.date?.message}
                  </FormHelperText>
                </LocalizationProvider>
              </Box>
            </Grid>
            <Grid item md={12}>
              <Box className="App">
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    extraPlugins: [uploadPlugin],
                    mediaEmbed: {
                      previewsInData: true,
                      extraProviders: [
                        {
                          name: "allow-all",
                          url: /^.+/,
                          html: (match) => `
                          <div style="background: #0f0f0f; height: 519px; display: flex; align-items: center; justify-content: center;" class="ck-media__wrapper" data-oembed-url="${match[0]}">
                            <div class="ck ck-reset_all ck-media__placeholder">
                              <div class="ck-media__placeholder__icon">
                                <a style="color: white; text-align: center;" class="ck-media__placeholder__url" target="new" href="${match[0]}">
                                <svg fill="#ffffff" height="80px" width="80px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-1 -1 62 62" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30 c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15 C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"></path> <path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30 S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"></path> </g> </g></svg>
                                </a>
                              </div>
                            </div>
                          </div>
                          `
                        }
                      ],
                    }
                  }}
                  data={value}
                  onReady={(editor) => handleEditorReady(editor)}
                  onBlur={(event, editor) => handleEditorChange(event, editor)}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setValue(data);
                  }}
                />
              </Box>
            </Grid>
            {/* <Grid item md={12} sx={{ mt: "10px" }}>
              <Grid container spacing={2}>
                <Grid item md={4}>
                  <Box>
                    <TextField
                      select
                      fullWidth
                      label={"Social Platform"}
                      {...register("socialP", {
                        onChange: (e) => handleSocialPlatform(e.target.value)
                      })}
                      error={errors?.socialP?.message}
                      helperText={errors?.socialP?.message}
                    >
                      {socialData.map((item, i) => (
                        <MenuItem key={i} value={item.value}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                </Grid>
                {selectedSocial.name !== "" && (
                  <Grid item md={7}>
                    <Box>
                      <InputField
                        label={`${selectedSocial?.name} Link`}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              {selectedSocial?.icon}
                            </InputAdornment>
                          )
                        }}
                        register={register(selectedSocial?.name)}
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                        error={errors?.[selectedSocial?.name]?.message}
                        helperText={errors?.[selectedSocial?.name]?.message}
                      />
                    </Box>
                  </Grid>
                )}
                {selectedSocial.name !== "" && (
                  <Grid item md={1}>
                    <Box>
                      <Button onClick={() => handleLinkAdd()} variant={"outlined"}>Add</Button>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item md={12}>
              <Grid container spacing={2} sx={{ mt: "10px" }}>
                {socialMediaLink.length > 0 && socialMediaLink?.map((item, i) => {
                  if (item?.f_link) {
                    return (
                      <Grid key={i} item md={12}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <FacebookRounded sx={{ color: Colors.primary }} />
                              <Typography>{item?.f_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                  if (item?.t_link) {
                    return (
                      <Grid key={i} item md={12}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <X sx={{ color: Colors.primary }} />
                              <Typography>{item?.t_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                  if (item?.l_link) {
                    return (
                      <Grid key={i} item md={12}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <LinkedIn sx={{ color: Colors.primary }} />
                              <Typography>{item?.l_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                  if (item?.w_link) {
                    return (
                      <Grid key={i} item md={12}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                              }}
                            >
                              <Instagram sx={{ color: Colors.primary }} />
                              <Typography>{item?.w_link}</Typography>
                              <IconButton
                                onClick={() => handleRemoveLink(item)}
                              >
                                <Close sx={{ fontSize: "16px", color: Colors.primary }} />
                              </IconButton>
                            </Box>
                          </Typography>
                        </Box>
                      </Grid>
                    )
                  }
                })}
              </Grid>
            </Grid> */}
            <Grid item md={12}>
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <PrimaryButton
                  title={"Submit"}
                  type={"submit"}
                  loading={loading}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fragment >
  )
}

export default CreateAdRead